/** 激励广告语言配置与单元版本 API，使用 Admin 标准鉴权和响应壳。 */
import type {
  RewardedAdConfig,
  RewardedAdLanguageConfigResponse,
  RewardedAdPlacement,
  RewardedAdUnitResponse,
  UpsertRewardedAdUnitRequest,
} from '@novel-admin/shared';
import { apiRequest } from '~/api/client';

const rewardedAdPath = (appId: string, resource: string) =>
  `/api/v1/apps/${encodeURIComponent(appId)}/${resource}`;

export const rewardedAdsApi = {
  listLanguages: (appId: string) =>
    apiRequest<RewardedAdLanguageConfigResponse[]>({
      method: 'GET',
      path: rewardedAdPath(appId, 'rewarded-ad-language-configs'),
    }),
  replaceLanguage: (appId: string, language: string, config: RewardedAdConfig) =>
    apiRequest<RewardedAdLanguageConfigResponse>({
      method: 'PUT',
      path: rewardedAdPath(appId, `rewarded-ad-language-configs/${encodeURIComponent(language)}`),
      body: { config },
    }),
  deleteLanguage: (appId: string, language: string) =>
    apiRequest<null>({
      method: 'DELETE',
      path: rewardedAdPath(appId, `rewarded-ad-language-configs/${encodeURIComponent(language)}`),
    }),
  listUnits: (appId: string) =>
    apiRequest<RewardedAdUnitResponse[]>({
      method: 'GET',
      path: rewardedAdPath(appId, 'rewarded-ad-units'),
    }),
  replaceUnit: (appId: string, placement: RewardedAdPlacement, body: UpsertRewardedAdUnitRequest) =>
    apiRequest<RewardedAdUnitResponse>({
      method: 'PUT',
      path: rewardedAdPath(appId, `rewarded-ad-units/${placement}`),
      body,
    }),
};
